<template>
    <div :class="option.multiple ? 'TTL-multiple' : 'TTL-select'" :style="{width:option.width}">
        <el-select 
            v-model="selectvalue" 
            :placeholder="option.placeholder" 
            :filterable="option.filterable" 
            :clearable="option.clearable"
            :multiple="option.multiple"
            @change="changeData"
        >
            <el-option v-for="(item,index) in selectlist" :key="index" :label="item.name" :value="item.id">
                <div class="TTL-select-infos"><span>{{item.name}}</span></div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
  props: ['value','list','option'],
  data() {
      return {
          selectvalue: this.value,
          selectlist: this.list,
          option: {
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请填写数据',      //空数据提示语
              clearable: this.option && this.option.clearable ? this.option.clearable : false,                 //是否有清空数据项
              filterable: this.option && this.option.filterable ? this.option.filterable : false,              //是否有搜索数据项
              multiple: this.option && this.option.multiple ? this.option.multiple : false,                    //是否开启多选
              width: this.option && this.option.width ? this.option.width : '220px',                           //选择框宽度
              ischange: this.option && this.option.ischange ? this.option.ischange : false,                    //是否允许修改参数
              isconfim:false,                                                                                  //参数修改前是否传递
          },
      }
  },

  watch: {

      value(val) {
          this.selectvalue=val;
      },

      list(val) {
          this.selectlist=val;
      },
      
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      changeData() {
          //数据修改变更开关关闭时，不往下执行
          if(!this.option.ischange) return false;  
          //提取数据名称
          var valuename='';  
          var thumb='';
          for(var i in this.selectlist) {
              this.selectvalue==this.selectlist[i].id ? valuename=this.selectlist[i].name : '';
              this.selectvalue==this.selectlist[i].id ? thumb=this.selectlist[i].thumb : '';
          }
          //不需要询问是否编辑时直接返回数据
          if(!this.option.isconfim) {this.$emit('finish',{type:'change',value:this.selectvalue,valuename:valuename,thumb:thumb});return false;}


          //需要询问进行修改数据时，进行询问操作
          this.$confirm.confirm('该操作将会批量修改数据，且不可恢复，是否执行 ？','取消操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
               this.$emit('finish',{type:'change',value:this.selectvalue,valuename:valuename,thumb:thumb});
               this.selectvalue=''; 
          }).catch(()=> {
                this.selectvalue=''; //取消参数选择
          });
      },

  }

}
</script>

<style scoped>
.TTL-select .el-select {width:100%}
::v-deep(.select-multiple .el-input__wrapper) {height: auto !important;}
</style>